import { X } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "../../helpers";
import * as styles from "./banner.styled";

type BannerProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
};

export const Banner = ({
  title,
  subtitle,
  onClose,
  closeLabel = "Close",
}: BannerProps) => {
  const text = (
    <>
      <p className={cn(styles.title, onClose && "w-full")}>{title}</p>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
    </>
  );

  if (!onClose) {
    return <div className={styles.root}>{text}</div>;
  }

  return (
    <div className={cn(styles.root, styles.rootClose)}>
      <div className={styles.textContainer}>{text}</div>
      <button
        type="button"
        aria-label={closeLabel}
        className={styles.closeButton}
        onClick={onClose}
      >
        <X className="w-5 text-white" />
      </button>
    </div>
  );
};
